import * as React from "react";
import { PlayerView } from '../playerview';
import { PlayerComponentProps, PlayerComponentState } from '../playercomponent';
import { PlayerWithProgressComponentCSSStyle } from './playerwithprogresscss';
import { RadialProgressBarComponent } from '../../radialprogressbar/radialprogressbarcomponent';
import { BaseContext } from 'src/com/sixdee/crbtportal/utils/basecontext';
import { UIComponentHandler } from '../../uicomponent';
import {RadialProgressBarCSSStyleImpl } from '../../radialprogressbar/radialprogressbarcss';
import { BannerProgressBarCSSStyleImpl } from '../../../components/home/banner/bannercard/bannerprogressbarcss';
import './player-with-progress-style.css';

export class PlayerWithProgressView extends PlayerView 
{
    private radialProgress: RadialProgressBarComponent;


    constructor(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler) {
        super(applicationContext, uiComponentHandler);

        // this.playerProgress = new AudioPlayerWithProgressImpl(applicationContext.getPlayerManager().getAudioPlayer());
    }

    draw(uiProps: PlayerComponentProps, uiState: PlayerComponentState, cssStyle: PlayerWithProgressComponentCSSStyle): JSX.Element | boolean {
        super.draw(uiProps, uiState, cssStyle);

        return (
            <div id="player-with-progress-play-div" style={cssStyle.getPlayDivCSSStyle()} >
            <RadialProgressBarComponent  children={this.getPlayer(uiProps, uiState, cssStyle)} cssStyle={this.getCSSStyle(uiProps)} ref={(item: any) =>{this.radialProgress = item;}} percentage={0} id={uiProps.id !== undefined ? uiProps.id : ""} context={uiProps.context}/>
            {/* {
               !uiState.isPlaying ? 
                 <img onClick={this.onPlayClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.playIconName)} />
                 :
                 <img onClick={this.onStopClicked} style={cssStyle.getPlayIconCSSStyle()} src={uiProps.context.getResources().getImage(uiProps.pauseIconName)} />
            } */}
            </div>);
    }  

   getPlayer(uiProps:PlayerComponentProps, uiState:PlayerComponentState, cssStyle:PlayerWithProgressComponentCSSStyle):JSX.Element
    {
        // 
        return(
            // style={cssStyle.getPlayIconCSSStyle()}
                        !uiState.isPlaying ? 
                        <img id="icon-div" onClick={this.onPlayClicked}  src={uiProps.context.getResources().getImage(uiProps.playIconName)} />
                        :
                        <img  id="icon-div" onClick={this.onStopClicked}  src={uiProps.context.getResources().getImage(uiProps.pauseIconName)} />
          
        
        );
    }
    onPlayClicked(e: any)
    {
        super.onPlayClicked(e);
    }


    updateProgress(currentPercentage: number)
    {   
        this.radialProgress !== null && this.radialProgress.updateDonutChart(currentPercentage, true);
    }

    getCSSStyle(Props:PlayerComponentProps):any
    {
        if(Props.radialProgressBarCSSStyle !== undefined)
        {
            return new BannerProgressBarCSSStyleImpl(Props.context);
        }
        else
        {
            return new RadialProgressBarCSSStyleImpl(Props.context);

        }
    }
   
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/toolkit/player/playerwithprogress/playerwithprogressview.tsx